
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { EnumProductTypeQuery } from '@xt/client/enums'
import { MixinsGoCourseItem } from '@xt/client/mixins'
import LazyImg from '@/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Mixins(MixinsGoCourseItem) {
  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
